module.exports = __webpack_public_path__ + "img/empty.ec124ebb.png";